import NotfoundPage from "@/components/error/NotfoundPage";
import withAuth from "@/hoc/WithAuth";
import AboutPage from "@/page/about/About";
import AdminPage from "@/page/admin/admin-page";
import Board from "@/page/Board/Board";
import Home from "@/page/Home";
import Login from "@/page/login";
import Test from "@/page/page/test";
import Project from "@/page/Project";

interface RoutePath {
  path: string;
  Component: React.ReactNode;
  subNav?: boolean; // 사이드바 여부
}

interface NavPage {
  path: string;
  pathName: string;
  AuthPage: boolean;
}

// Protected
const ProtectedAdminPage = withAuth(AdminPage, "/");

export const ROUTE_PATH: RoutePath[] = [
  { path: "/", Component: <Home /> },
  { path: "/test", Component: <Test /> },
  { path: "/work/*", Component: <Project /> },
  { path: "/guestboard", Component: <Board /> },
  // { path: "/about", Component: <AboutPage /> },
  { path: "/*", Component: <NotfoundPage redirectPath={"/"} /> },
  { path: "/login", Component: <Login /> },
  { path: "/admin", Component: <ProtectedAdminPage /> },
];

export const NAVPAGE_OBJECT: NavPage[] = [
  // { path: "/about", pathName: "Resume", AuthPage: false },
  { path: "/work", pathName: "Work", AuthPage: false },
  { path: "/guestboard", pathName: "Guest Board", AuthPage: false },
  { path: "/admin", pathName: "admin", AuthPage: true },
];
